const CHART_RETURN_PATH = /^\/(?:charts|maps?)(?:\/|$)/;

export function chartReturnPath(currentPath, useNewWebCharts = false) {
  const fallback = useNewWebCharts ? '/charts' : '/map/';
  if (!currentPath) return fallback;
  const pathname = currentPath.split('#')[0].split('?')[0];
  return CHART_RETURN_PATH.test(pathname) ? currentPath : fallback;
}

export function signInUrl(loginUrl, currentPath, useNewWebCharts = false) {
  const returnTo = encodeURIComponent(chartReturnPath(currentPath, useNewWebCharts));
  const joiner = loginUrl.indexOf('?') === -1 ? '?' : '&';
  return `${loginUrl}${joiner}redirectUrl=${returnTo}`;
}



// WEBPACK FOOTER //
// ./src/utils/urls/signInUrl.js